import './index.scss';
const ResponsibleGaming = () => {
	return (
		<div className="responsibleGaming">
			<div className="content">
				<div className="title">Política de jogo responsável</div>
				<div className="textItem">
					<p>{`Data: 10/2024`}</p>
					<p>{`Versão: 3.1`}</p>
					<p>{`A Mourgames valoriza os seus jogadores e orgulha-se de ser escolhida como plataforma de apostas esportivas e jogos online. Nossa missão é oferecer entretenimento de maneira segura e responsável, proporcionando uma experiência positiva a todos os nossos apostadores. Em vista disso, alertamos para o uso consciente da nossa plataforma e recomendamos que você utilize nossas ferramentas de controle para gerenciar o seu tempo e gastos, programar pausas, monitorar sua atividade e verificar sua experiência com as apostas, de forma saudável.`}</p>
					<p>{`Lembre-se de que o jogo é entretenimento e deve ser feito com moderação e de forma responsável, seguindo todas as orientações desta Política e dos canais de comunicações, bem como demais informações relacionadas ao Jogo Responsável. Tenha em mente que, ao apostar, você coloca o seu dinheiro em risco na expectativa de ganhar um prêmio. Caso tenha dúvidas sobre nossos produtos, acesse as descrições detalhadas de cada um ou entre em contato com nosso suporte.`}</p>
					<p>{`O programa de jogo responsável da Mourgames concentra-se no impacto social do jogo, baseando-se em três premissas:`}</p>
					<ul>
						<li>
							Prevenir problemas em face dos riscos de dependência e transtornos do jogo patológico
							em relação a apostas esportivas e jogos online de entretenimento.
						</li>
						<li>
							Prevenir a realização de apostas esportivas de jogos online de entretenimento por
							menores de idade.
						</li>
						<li>Garantir que o jogo seja conduzido de maneira justa.</li>
					</ul>
					<p>{`A Mourgames reconhece que apostar de forma irresponsável pode ocasionar consequências negativas para os jogadores, por isso, em todas as suas ações, a Mourgames incentiva o jogo responsável para seus jogadores e orienta seus colaboradores e parceiros acerca de práticas que devem ser adotadas para identificar e coibir o jogo irresponsável.`}</p>
					<p>{`A Mourgames permite que o apostador defina limites diários, semanais e mensais de depósitos, apostas e perdas, garantindo que o próprio apostador delimite, de forma responsável, os recursos que podem ser utilizados na plataforma. A Mourgames também permite que o apostador realize uma pausa temporária e/ou se autoexclua, garantindo que o apostador tenha controle sobre o tempo que irá dispender na plataforma. A Mourgames também poderá, a qualquer momento, delimitar limites para o apostador ou encerrar permanentemente sua conta, caso entenda ser adequado em função dos controles internos de jogo responsável e em aderência as legislações locais.`}</p>
					<p>{`Adicionalmente, a Mourgames oferece treinamentos e orientação interna, especialmente para a equipe de atendimento ao cliente e funcionários corporativos e dispõe de canal sistemático que alerta o apostador acerca jogo responsável, riscos de dependência e de transtornos do jogo patológico, formas de prevenção e alternativas de tratamento.`}</p>
					<p className="pH2">Sinais de alerta</p>
					<p>{`Se estiver preocupado com o fato de o jogo ter um impacto negativo na sua vida ou na vida de terceiros, as seguintes perguntas do questionário de autoavaliação podem ajudá-lo a identificar sinais de alerta para autovigilância de jogo irresponsável:`}</p>
					<ul>
						<li>Você já negligenciou seus estudos ou trabalho devido ao jogo?</li>
						<li>Você joga para passar o tempo ou sair do tédio?</li>
						<li>Você joga sozinho e por longos períodos de tempo?</li>
						<li>Alguém já criticou seu hábito de jogo?</li>
						<li>Você já perdeu o interesse pela família, amigos ou hobbies devido ao jogo?</li>
						<li>
							Você está relutante em gastar seu dinheiro reservado para jogo com despesas úteis e
							necessárias?
						</li>
						<li>Você joga até perder todo o seu dinheiro?</li>
						<li>
							Depois de perder, você sente a necessidade de jogar o mais rápido possível para cobrir
							as perdas?
						</li>
						<li>Há momentos em que o jogo se segue a discussões, frustrações ou decepções?</li>
						<li>Você joga para pagar suas dívidas ou resolver seus problemas financeiros?</li>
						<li>Já mentiu sobre a quantidade de dinheiro e o tempo gasto em jogos de azar?</li>
					</ul>
					<p>{`Quanto mais destas perguntas você responder "sim", maior é a probabilidade de estar com problemas com o jogo. A Mourgames colabora com organizações que oferecem apoio psicológico e conversas de suporte para aqueles que possam estar enfrentando dificuldades relacionadas ao jogo. Caso sinta que precise de apoio, entre em contato conosco.`}</p>
					<p className="pH2">Definição de limite</p>
					<p>{`A Mourgames permite que seus jogadores definam limites de depósito, e perdas, de modo que o apostador possa usar a plataforma Mourgames de forma saudável e responsável.`}</p>
					<p>{`Cada uma das seguintes opções de limite está disponível para os jogadores. Os jogadores podem usar quantas opções disponíveis preferirem.`}</p>
					<ul>
						<li>
							Limite de depósito: Defina um limite máximo de depósito para um período de tempo
							selecionado: diário, semanal ou mensal ou anual.
						</li>
						<li>
							Limite de gastos: Defina um limite de gasto máximo de aposta para um período de tempo
							selecionado: diário, semanal ou mensal ou anual.
						</li>
						<li>
							Limite de tempo: Defina um limite de tempo de utilização da plataforma para um período
							de tempo selecionado: diário, semanal ou mensal ou anual.
						</li>
						<li>
							Limite por pausa temporária: Selecione quando quiser suspender temporariamente a conta
							por um período determinado.
						</li>
						<li>
							Acesso limitado: Limite, por período definido, seu acesso para bloquear novas apostas
							e aportes financeiros, sendo permitido acessar a plataforma para resgate de recursos.
						</li>
						<li>
							Autoexclusão: Você pode excluir sua conta por um período determinado ou indeterminado.
						</li>
					</ul>
					<p>{`Além disso, os jogadores podem acessar, em seu Painel do Jogador, informações referentes à sua conta de apostador, a seu histórico e a sua situação atual no nosso Site quanto a tempo e valores gastos em apostas. Para acesso aos limites e às informações, é necessário estar logado e acessar a aba “Minha Conta”.`}</p>
					<p className="pH2">
						COMPROMISSO COM A PREVENÇÃO DE JOGOS ONLINE DE ENTRETENIMENTO PARA MENORES DE IDADE
					</p>
					<p>{`Um aspecto central do programa de Jogo Responsável da Mourgames é a prevenção do jogo para menores. A Mourgames não permite a utilização de sua plataforma por menores de idade. Um jogador deve ter mais de 18 anos (ou 21 anos, conforme legislação aplicável) para se registrar e apostar na plataforma EstrelaBet.`}</p>
					<p>{`Caso, em alguma das rotinas de KYC (Conheça seu Cliente) e controles internos da EstrelaBet, haja suspeita de que uma conta seja ou esteja sendo usada por menor de idade, a Mourgames poderá suspender permanentemente a conta e adotar demais diligências conforme a legislação aplicável.`}</p>
					<p>{`A Mourgames recomenda que os jogadores garantam que as informações de sua conta estejam seguras. Os pais e outros adultos responsáveis devem estar atentos à possibilidade de que os menores possam acessar suas contas e senhas ou usar meios de pagamento e informações pessoais para criar uma conta indevidamente. Por isso, é importante que as informações da conta nunca sejam acessíveis a menores de idade.`}</p>
					<p>
						Adicionalmente, a Mourgames recomenda o download de ferramentas de filtragem em seu
						computador ou dispositivo móvel. Caso você compartilhe o seu computador ou dispositivo
						móvel com amigos ou familiares menores de idade e, por isso, impedidos de se registrarem
						ou apostarem em nossa plataforma, considere as soluções de filtragem parental, como:
						{
							<span
								className="ulSpan"
								onClick={() => {
									window.open('https://www.mourgames.com/');
								}}
							>
								https://www.mourgames.com/
							</span>
						}{' '}
						e
						{
							<span
								className="ulSpan"
								onClick={() => {
									window.open('https://www.mourgames.com/');
								}}
							>
								https://www.mourgames.com/
							</span>
						}
						.
					</p>
					<p className="pH2">CANAIS DE ATENDIMENTO</p>
					<p>{`A Mourgames preza pela comunicação e pelo jogo saudável. Para isso disponibilizamos canais de proteção ao apostador e estabelecemos parceria com instituições que promovem o atendimento psicológico a pessoas que estejam enfrentando problemas relacionados ao jogo. A pedido do jogador e a critério da Mourgames e das referidas instituições, o jogador poderá ser direcionado para sessões de atendimento gratuitas.`}</p>
					<p>{`Portanto, se você verificar que precisa de ajuda, entre em contato com o canal de atendimento psicológico especializado da Mourgames abaixo. Ele é gratuito e confidencial.`}</p>
					<p className="pH2">Atendimento Mourgames :</p>
					<p>
						<span
							className="ulSpan"
							onClick={() => {
								window.open('https://www.mourgames.com/');
							}}
						>
							https://www.mourgames.com/.
						</span>
					</p>
					<p>{`Você também pode procurar ajuda em alguma das organizações de aconselhamento disponíveis:`}</p>
					<ul>
						<li>
							Programa Ambulatorial do Jogo Patológico do Hospital das Clínicas do Instituto de
							Psiquiatria do HCFMUSP
							<br></br>
							Rua Dr. Ovídio Pires de Campos, 785 – Cerqueira César – São Paulo – SP
							<br></br>
							Email: <span className="ulSpan">service@mourgames.com</span>
						</li>
						<li>
							Associação Viver Bem
							<br></br>
							Rua Artur de Azevedo, 147 – Cerqueira César – São Paulo – SP
							<br></br>
							Email: <span className="ulSpan">service@mourgames.com</span>
						</li>
						<li>
							PROAD (Programa de Orientação e Atendimento a Dependentes) – Universidade Federal de
							São Paulo
						</li>
						<li>
							Santa Casa de Misericórdia
							<br></br>
							Rua Santa Luzia, 206 – Centro – Rio de Janeiro – RJ
						</li>
						<li>
							Terapia de Jogo – Gordon Moody
							<br></br>
							<span
								className="ulSpan"
								onClick={() => {
									window.open('https://www.mourgames.com/');
								}}
							>
								https://www.mourgames.com/
							</span>
						</li>
						<li>
							Jogadores Anônimos
							<br></br>
							<span
								className="ulSpan"
								onClick={() => {
									window.open('https://www.mourgames.com/');
								}}
							>
								https://www.mourgames.com/
							</span>
						</li>
						<li>
							Grupo Salvando Vidas
							<br></br>
							<span
								className="ulSpan"
								onClick={() => {
									window.open('https://www.mourgames.com/');
								}}
							>
								https://www.mourgames.com/
							</span>
						</li>
						<li>
							Sala de Apoio à Gestão Estratégica do Ministério da Saúde
							<br></br>
							<span
								className="ulSpan"
								onClick={() => {
									window.open('https://www.mourgames.com/');
								}}
							>
								https://www.mourgames.com/
							</span>
						</li>
						<li>
							Escola Paulista de Medicina
							<br></br>
							Av. Ascendino Reis, 763 – Vila Clementino – São Paulo – SP
							<br></br>
							Email: <span className="ulSpan">service@mourgames.com</span>
						</li>
						<li>
							Em caso de dúvidas ou informações, por favor, entre em contato pelo nosso canal de
							suporte
							<br></br>
							<span
								className="ulSpan"
								onClick={() => {
									window.open('https://www.mourgames.com/');
								}}
							>
								https://www.mourgames.com/
							</span>
						</li>
					</ul>
					<p>{``}</p>
				</div>
			</div>
		</div>
	);
};
export default ResponsibleGaming;
